// actions.js
/*import { LOAD_JOYRIDE_STEPS, SET_CURRENT_STEPS } from '../actions/userGuideActionTypes';

export const loadJoyrideSteps = (steps) => ({
  type: LOAD_JOYRIDE_STEPS,
  payload: steps,
});

export const setCurrentSteps = (steps) => ({
  type: SET_CURRENT_STEPS,
  payload: steps,
});*/

// userGuideActions.js
import { LOAD_JOYRIDE_STEPS, SET_CURRENT_STEPS, START_TOUR, STOP_TOUR, NEXT_STEP, SET_TOUR_STATE } from './userGuideActionTypes';

export const loadJoyrideSteps = (steps) => ({
  type: LOAD_JOYRIDE_STEPS,
  payload: steps,
});

export const setCurrentSteps = (steps) => ({
  type: SET_CURRENT_STEPS,
  payload: steps,
});

export const startTour = () => ({
  type: START_TOUR,
});

export const stopTour = () => ({
  type: STOP_TOUR,
});

export const nextStep = () => ({
  type: NEXT_STEP,
});

export const setTourState = (state) => ({
  type: SET_TOUR_STATE,
  payload: state,
});
